import React from "react";

import "./PrivacyPolicyWindow.scss";

const PrivacyPolicyWindow = () => {
  return (
    <div className="PrivacyPolicyWindow">
      <section className="PrivacyPolicy">
        <div className="PrivacyPolicy__Wrapper">
          <div className="PrivacyPolicy__Header">
            <h3>Privacy Policy</h3>
            <span>Last updated: March 23, 2026</span>
          </div>

          <div className="PrivacyPolicy__Content">
            <h4>Overview</h4>
            <p>
              This site does not collect any personal information. We use
              minimal cookies solely to enable YouTube video playback.
            </p>

            <h4>Cookies</h4>
            <p>
              When you accept cookies, YouTube may set cookies on your device
              according to their own privacy policy. We do not use analytics
              cookies or tracking cookies of any kind.
            </p>

            <h4>Guestbook</h4>
            <p>
              The guestbook collects anonymous messages only. No name, email, or
              any personally identifiable information is required or stored.
            </p>

            <h4>Third-Party Services</h4>
            <p>We use the following third-party services:</p>
            <ul>
              <li>YouTube — video/audio playback</li>
              <li>Supabase — anonymous guestbook storage</li>
              <li>
                Cloudflare — website hosting and privacy-friendly analytics
              </li>
            </ul>

            <h4>Contact</h4>
            <p>
              If you have any questions, feel free to reach out at{" "}
              <a href="mailto:chae3929@gmail.com">chae3929@gmail.com</a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyWindow;
